import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { APP } from 'libs/constants';
import { getGoogleAuthCbParam } from 'libs/auth';
import Loader from 'components/Loader';
import { getAuthUser } from 'redux/actions/auth';
import SubscriptionActivate from './SubscriptionActivate';

class SubscriptionActivateWrapper extends Component {
  componentWillMount() {
    const { auth, intl } = this.props;
    const app = APP.muse;
    const params = getGoogleAuthCbParam();
    if (!auth.info && !params) {
      this.props.getAuthUser({ app, intl });
    }
  }

  render() {
    const {
      auth: { isFetching, info }
    } = this.props;

    if ((isFetching && !info)) {
      return (
        <Loader />
      );
    }
    return (
      <SubscriptionActivate
        {...this.props}
        app={APP.muse}
      />
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

SubscriptionActivateWrapper.propTypes = {
  route: PropTypes.object.isRequired,
  getAuthUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired
};

export default connect(mapStateToProps, { getAuthUser })(injectIntl(SubscriptionActivateWrapper));



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/SubscriptionActivateWrapper.jsx